import React from 'react';
import { FilterSelect } from '../../shared/table/FilterSelect';

export const TaskListFiltersDrawer = ({
    isOpen,
    onClose,
    searchField,
    searchFieldOptions,
    onSearchFieldChange,
    searchTerm,
    onSearchTermChange,
    statusFilter,
    statusOptions,
    onStatusFilterChange,
    customerFilter,
    customerOptions,
    onCustomerFilterChange,
    projectFilter,
    projectOptions,
    onProjectFilterChange,
    typeFilter,
    typeOptions,
    onTypeFilterChange,
    rowsPerPage,
    rowsOptions,
    onRowsPerPageChange,
    onClearFilters,
}) => {
    React.useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="ticket-filters-drawer-overlay" onClick={onClose}>
            <aside className="ticket-filters-drawer" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-label="Filtros de tickets">
                <div className="ticket-filters-drawer__header">
                    <div>
                        <h6 className="mb-0 fw-bold">Filtro</h6>
                    </div>
                    <button type="button" className="btn btn-sm btn-light" onClick={onClose}>
                        <i className="feather-x" />
                    </button>
                </div>

                <div className="ticket-filters-drawer__body">
                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Buscar por</label>
                        <FilterSelect
                            value={searchField}
                            options={searchFieldOptions}
                            onChange={onSearchFieldChange}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Buscar</label>
                        <input
                            type="search"
                            className="form-control"
                            placeholder="Buscar tickets..."
                            value={searchTerm}
                            onChange={(event) => onSearchTermChange(event.target.value)}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Estado</label>
                        <FilterSelect
                            value={statusFilter}
                            options={statusOptions}
                            onChange={onStatusFilterChange}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Cliente</label>
                        <FilterSelect
                            value={customerFilter}
                            options={customerOptions}
                            onChange={onCustomerFilterChange}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Proyecto</label>
                        <FilterSelect
                            value={projectFilter}
                            options={projectOptions}
                            onChange={onProjectFilterChange}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Tipo</label>
                        <FilterSelect
                            value={typeFilter}
                            options={typeOptions}
                            onChange={onTypeFilterChange}
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Mostrar</label>
                        <FilterSelect
                            value={rowsPerPage}
                            options={rowsOptions.map((value) => ({ value, label: String(value) }))}
                            onChange={(nextValue) => onRowsPerPageChange(Number(nextValue))}
                        />
                    </div>
                </div>

                <div className="ticket-filters-drawer__footer">
                    <button
                        type="button"
                        className="btn btn-outline-secondary w-100"
                        onClick={onClearFilters}
                    >
                        Limpiar filtros
                    </button>
                </div>
            </aside>
        </div>
    );
};